import React from 'react';
import '../../assets/styles/PaymentMethod.css';
import { cardClasses } from '@mui/material';

const PaymentMethod = ({ onPaymentMethodChange, item, isPaymentDisabled, onPaymentBlocked }) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    React.useState('cash');

  React.useEffect(() => {
    const paymentMethod = item?.paymentMethod;
    if (paymentMethod === 'CREDIT' || paymentMethod === 'credite') {
      setSelectedPaymentMethod('credite');
    } else if (paymentMethod === 'DEBIT' || paymentMethod === 'debit') {
      setSelectedPaymentMethod('debit');
    } else if (paymentMethod === 'PIX' || paymentMethod === 'pix') {
      setSelectedPaymentMethod('pix');
    } else if (paymentMethod === 'cash') {
      setSelectedPaymentMethod('cash');
    } else if (paymentMethod && paymentMethod.startsWith('VR')) {
      setSelectedPaymentMethod('vr');
    } else {
      setSelectedPaymentMethod('cash');
    }
  }, [item?.paymentMethod, item?.id]);

  const handleChange = (e) => {
    const { value } = e.target;
    setSelectedPaymentMethod(value);
    onPaymentMethodChange(value, item);
  };

  const handleWrapperClick = (e) => {
    if (isPaymentDisabled) {
      e.preventDefault();
      e.stopPropagation();
      if (onPaymentBlocked) onPaymentBlocked();
    }
  };

  const itemId = item?.id || 'default';
  const groupName = `payment-options-${itemId}`;

  return (
    <div 
      className="paymentMethod-container" 
      onClickCapture={handleWrapperClick}
      style={isPaymentDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
    >
      <div>
        <input
          className="form-check-input"
          id={`cash-${itemId}`}
          value="cash"
          name={groupName}
          type="radio"
          checked={selectedPaymentMethod === 'cash'}
          onChange={handleChange}
        />
        <label htmlFor={`cash-${itemId}`} className="form-check-label">Dinheiro</label>
      </div>
      <div>
        <input
          className="form-check-input"
          id={`credite-${itemId}`}
          value="credite"
          name={groupName}
          type="radio"
          checked={selectedPaymentMethod === 'credite'}
          onChange={handleChange}
        />
        <label htmlFor={`credite-${itemId}`} className="form-check-label">Crédito</label>
      </div>
      <div>
        <input
          className="form-check-input"
          id={`debit-${itemId}`}
          value="debit"
          name={groupName}
          type="radio"
          checked={selectedPaymentMethod === 'debit'}
          onChange={handleChange}
        />
        <label htmlFor={`debit-${itemId}`} className="form-check-label">Débito</label>
      </div>
      <div>
        <input
          className="form-check-input"
          id={`pix-${itemId}`}
          value="pix"
          name={groupName}
          type="radio"
          checked={selectedPaymentMethod === 'pix'}
          onChange={handleChange}
        />
        <label htmlFor={`pix-${itemId}`} className="form-check-label">Pix</label>
      </div>
      <div>
        <input
          className="form-check-input"
          id={`vr-${itemId}`}
          value="vr"
          name={groupName}
          type="radio"
          checked={selectedPaymentMethod === 'vr'}
          onChange={handleChange}
        />
        <label htmlFor={`vr-${itemId}`} className="form-check-label">VR</label>
      </div>
    </div>
  );
};

export default PaymentMethod;
